import React, { useRef } from "react";
import "../../css/components/TestimonialsSlider.css";

const testimonials = [
  {
    name: "Paul H",
    text: [
      "“Having met Merrick through my late father and knowing that he was the family financial advisor, it was the perfect decision to continue and engage Merrick to look after all my financial requirements. Merrick has provided support and guidance to myself, my good lady and my son with respect to finding the best products on the market. He is knowledgeable and provides expert advice without pushing any particular products.” ",
    ],
  },
  {
    name: "Melanie N",
    text: [
      "“Thank you Merrick, for not only making the process of reviewing my existing pension arrangements a simple and easy process to negotiate, you also guided me through setting up a new investment, and gave me a better understanding of it. You have helped take the stress out of making difficult decisions. I have no hesitation to recommend you further to friends requiring similar services.” ",
    ],
  },
  //   {
  //     name: "Rob M",
  //     text: [
  //       "“I first used Merrick in the early 90’s where I required myself to be added to a mortgage which my wife’s ex-husband was still included on.  It wasn’t an easy task, made more difficult as I had recently become self-employed.  None of this phased Merrick and he persevered until he got the right product in place for us.   We have since used him for all of our financial advice and products, not only for us but the whole of the immediate and extended family.",
  //       ,
  //       "Our youngest daughter has just bought her first property and was assisted by Merrick.  Her mortgage was rapidly agreed and put into place, and I am happy to see the next generation of my family being advised and guided by Merrick.",
  //       "I would and always do recommend all of his services without hesitation.”",
  //     ],
  //   },
  {
    name: "Kev B",
    text: [
      "“We have known Merrick for over 20 years, and on every occasion we have asked for advice, his recommendations have always been excellent and achieved the financial outcome we were looking for. He listens and is friendly and professional.” ",
    ],
  },
  {
    name: "Julie M",
    text: [
      "“My family and I have used Merrick Platts for many years for all our financial needs, he has been very professional and helped us through some hard phases.",
      "Merrick has always managed to find us the best places to invest our money even in these hard times, I wouldn't use anyone else.” ",
    ],
  },
];

export default function TestimonialsSlider() {
  const sliderRef = useRef(null);

  const scrollSlide = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const slideWidth = slider.clientWidth;

    slider.scrollBy({
      left: direction === "left" ? -slideWidth : slideWidth,
      behavior: "smooth",
    });
  };

  return (
    <div className="testimonials-slider-container">
      <div className="testimonials-slider" ref={sliderRef}>
        {testimonials.map((item, index) => (
          <div className="testimonial-slide" key={index}>
            <div className="testimonial-card">
              <div className="testimonial-text">
                {item.text.map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
              <h4 className="testimonial-name">{item.name}</h4>
            </div>
          </div>
        ))}
      </div>
      <div className="testimonial-arrows-bottom">
        <button
          className="testimonial-arrow testimonial-arrow-left"
          onClick={() => scrollSlide("left")}
          aria-label="Previous testimonial"
        >
          ‹
        </button>
        <button
          className="testimonial-arrow testimonial-arrow-right"
          onClick={() => scrollSlide("right")}
          aria-label="Next testimonial"
        >
          ›
        </button>
      </div>
    </div>
  );
}
